import { Badge, Flex, Text } from '@radix-ui/themes'

import React from 'react'
type Props = {
  title: string
  badgeText: string
}

const ActionTitleWithBadge = ({ title, badgeText }: Props): React.ReactNode => {
  return (
    <Flex gap="2">
      <Text size="2">{title}</Text>
      <Badge color="blue" variant="outline">
        {badgeText}
      </Badge>
    </Flex>
  )
}

export default ActionTitleWithBadge
